import { render, staticRenderFns } from "./ProductItemList.vue?vue&type=template&id=331644f9&scoped=true"
import script from "./ProductItemList.vue?vue&type=script&lang=js"
export * from "./ProductItemList.vue?vue&type=script&lang=js"
import style0 from "./ProductItemList.vue?vue&type=style&index=0&id=331644f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331644f9",
  null
  
)

export default component.exports